import React from 'react';
import { SolutionAboutProps } from '../../types/solution';
import OptimizedImage from '../about/OptimizedImage';

const SolutionAbout: React.FC<SolutionAboutProps> = ({ data, image }) => {
  if (!data && !image) {
    return <div>Loading about section...</div>;
  }

  return (
    <section id="about" className="about section">
      <div className="container" data-aos="fade-up" data-aos-delay="100">
        <div className="row gx-2 align-items-xl-center text-center gy-md-5">
          <div className="col-xl-12 content mt-md-4 mt-sm-0">
            <div className="row gy-4 icon-boxes">
              <div className="offset-md-1 col-md-10">
                <label className="label-title">
                  {data?.field_description?.[0]?.value}
                </label>
                <p 
                  className="mb-5 px-lg-5" 
                  dangerouslySetInnerHTML={{ __html: data?.field_content?.[0]?.value || '' }}
                />
                
                {image && (
                  <OptimizedImage
                    src={image?.thumbnail?.[0]?.url}
                    className="img-fluid mb-3"
                    alt="Solution About"
                    loading="lazy"
                  />
                )}

                <p className="mb-4 px-lg-5">
                  {data?.field_sub_description?.[0]?.value}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionAbout;
